import React from "react";

import { formatISODateTime } from "@/react/datetime";

const DateCell = (props) => {
  const formattedDate = formatISODateTime(props.value);
  return <>{formattedDate}</>;
};

export default DateCell;
